import 'sass/blocks/_documentation-info.scss';
import cmsActions from 'actions/cmsActions';
import creditCardActions from 'actions/creditCardActions';
import documentationActions from 'actions/documentationActions';
import initialActions from 'actions/initialActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import preLoaderActions from 'actions/preLoaderActions';
import promotionalCodeAction from 'actions/promotionalCodeAction';
import scoringActions from 'actions/scoringActions';
import standByActions from 'actions/standByActions';
import stepsActions from 'actions/stepsActions';
import iconComplementaryLink from 'assets/icons/arrow-complementary_link.svg';
import copyIbanButton from 'assets/icons/copyIbanButton.svg';
import CREDIT_CARD_BASIC from 'assets/images/credit-card-basic-background.svg';
import classNames from 'classnames';
import Accordion from 'components/commons/accordion/accordion';
import AccordionBody from 'components/commons/accordion/accordionBody/accordionBody';
import MessageBox from 'components/commons/MessageBox/MessageBox';
import { AuthorizedCreditCard } from 'components/documentationInfo/authorizedCreditCard';
import ButtonUnderstood from 'components/documentationInfo/ButtonUnderstood';
import DocumentationCard from 'components/documentationInfo/DocumentationCard';
import DocumentationContact from 'components/documentationInfo/DocumentationContact';
import FeatureSection from 'components/documentationInfo/FeatureSection';
import Product from 'components/documentationInfo/product';
import FormattedTextWithComponents from 'components/FormattedTextWithComponents/FormattedTextWithComponents';
import Headline from 'components/headline';
import IdentificationCard from 'components/identificationCard';
import JointHolderStatusCard from 'components/jointHolders/cardBox/jointHolderStatusCard';
import { STANDBY_FINAL } from 'constants/cms';
import { SIGNATURE_KEY_ENABLED } from 'constants/featureFlagging';
import {
    CORREOS,
    COURIER,
    IBAN,
    JOINT_HOLDER_AUTORIZED,
    TRANSFER_CERTIFICATE,
    VIDEO_CALL,
    VIDEO_SELFIE,
} from 'constants/identityMethod';
import { DGS, INVD, ISIN } from 'constants/products';
import { CREDIT_CARD, GBI, GBI_REJECTED, ROBO, ROBO_REJECTED } from 'constants/userProfile';
import { FormattedText, formatText } from 'core/i18n';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendTextToClipBoard } from 'utilities/clipBoardHelper';
import { getCreditCardImage } from 'utilities/creditCard/creditCard';
import { createCardsMessagesWith } from 'utilities/documentationOptions/documentationOptions.js';
import { isDeposit } from 'utilities/onboardingTypeHelper';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import buildTagging from './tagging';
import { isMobile } from 'utilities/browser';

const DocumentationInfo = ({
    userProfile,
    userProfile: { investmentType, onboardingType },
    documentation,
    partner,
    flags,
    initialActions,
    preLoaderActions,
    cmsActions,
    scoringActions,
    jointHoldersStatusActions,
    documentationActions,
    creditCardActions,
    wealthProduct,
    products,
    initialStep,
    promotionalCode,
    immJointHoldersStatus,
    standByActions,
}) => {
    const [documentsCompleted, setDocumentsCompleted] = useState([]);
    const [creditCardLimit, setCreditCardLimit] = useState(0);
    const [isCopied, setIsCopied] = useState(false);

    const { doTagContinueButtonClick } = buildTagging({
        userProfile,
        productDetail: products.get('productsDescription'),
    });

    const getCompletedDocuments = () => {
        documentationActions.getInformationDocument(
            userProfile.accessToken,
            (response, data) => {
                if (response) setDocumentsCompleted(data.documents);
            },
            'COMPLETED'
        );
    };

    const fetchAndSetCreditCardLimit = async () => {
        const limit = await creditCardActions.getCreditCardLimit(userProfile.accessToken);
        setCreditCardLimit(limit);
    };

    useEffect(() => {
        standByActions.getHoldingStatus();
    }, []);

    useEffect(() => {
        if (userProfile.isJointHolderAccount) {
            jointHoldersStatusActions.statusHolders(userProfile.accessToken);
        }

        getCompletedDocuments();
        preLoaderActions.showPreLoader2();
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        scoringActions.getLimitJaffar(userProfile.accessToken);
        initialActions.documentationIsLoaded();
        preLoaderActions.hidePreLoader2();
        cmsActions.getCMSStandby(STANDBY_FINAL);

        if (userProfile.investmentType === CREDIT_CARD) {
            fetchAndSetCreditCardLimit();
        }
    }, []);

    const getOpenCreditText = () => {
        return <FormattedText value="CMS-standByFinalTC" />;
    };

    const renderProducts = () => {
        const productsInfo = products.get('products');
        const renderProducts = [];
        let showCard = false;

        if (productsInfo.size > 0 && initialStep.get('isLoadedInDocumentationInfo')) {
            const products = [];
            productsInfo.map(info => {
                products[info.id] = info;
                if (info.cardDesignUrl) {
                    showCard = true;
                }
            });

            let colNumber;
            if (showCard) {
                colNumber = products.length === 3 ? 6 : 4;
            } else {
                colNumber = products.length === 3 ? 4 : 6;
            }

            let i = 0;
            const productList = [];
            const productListCard = [];
            let productClassNames;
            let titleClassNames;
            let line;
            let currentColNumber;
            let cardDesignUrl;
            let renderProduct;
            let numberRenderProduct = 0;
            let numberRenderProductCard = 1;
            products.map((product, index) => {
                if (product.text !== 'products-textOpenCredit') {
                    cardDesignUrl = product.cardDesignUrl;
                    if (cardDesignUrl) {
                        if (colNumber === 6) {
                            currentColNumber = 12;
                        } else {
                            currentColNumber = 9;
                        }
                    } else {
                        currentColNumber = colNumber;
                    }

                    line = <hr className="visible-xs" />;
                    productClassNames = classNames(
                        'col-xs-12',
                        'products-list__product',
                        `col-sm-${currentColNumber}`,
                        {
                            'products-list__margin-top':
                                cardDesignUrl && currentColNumber === 12 && numberRenderProductCard === 0,
                            'products-list__margin-bottom':
                                cardDesignUrl && currentColNumber === 12 && numberRenderProductCard === 1,
                        }
                    );

                    titleClassNames = classNames('font-heading5', {
                        'products-list__single-title': products.length > 2 && currentColNumber !== 12,
                    });

                    renderProduct = (
                        <Product
                            id={`product${i}`}
                            key={i}
                            productClassNames={productClassNames}
                            titleClassNames={titleClassNames}
                            description={product.description}
                            text={product.text}
                            card={cardDesignUrl}
                            line={line}
                            fullCard={currentColNumber === 12}
                            userProfile={userProfile}
                        />
                    );

                    if (cardDesignUrl && currentColNumber === 12) {
                        productListCard[i] = renderProduct;
                        if (index === 0) {
                            numberRenderProduct = 1;
                            numberRenderProductCard = 0;
                        }
                    } else {
                        productList[i] = renderProduct;
                    }
                }
                i++;
            });

            if (productListCard.length) {
                renderProducts[numberRenderProductCard] = (
                    <div className="products-list" key={`pl-${numberRenderProductCard}`}>
                        <div className="row" key={`products${numberRenderProductCard}`}>
                            {productListCard}
                        </div>
                    </div>
                );
            }

            renderProducts[numberRenderProduct] = <Fragment key={`pl-${numberRenderProduct}`}>{productList}</Fragment>;
        }

        if (showCard) {
            const last = renderProducts.pop();
            renderProducts.unshift(last);
        }

        return renderProducts;
    };

    const handleCopyIban = iban => {
        if (!isCopied) {
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
            sendTextToClipBoard(iban);
        }
    };

    const renderIdentificationCard = method => {
        const messages = createCardsMessagesWith(method, documentsCompleted);
        let { identificationMethodTextKey } = messages;
        const { isMatchTransferCertificate, isMatchAnyExtraDocuments } = messages;

        let identificationMethodCard, identificationIcon, identificationClassName, identificationTitleKey;

        const TRANSFER = 'transfer';
        const VIDEOCALL_CAMELCASE = 'videoCall';

        switch (method) {
            case TRANSFER_CERTIFICATE:
                identificationIcon = TRANSFER;
                identificationClassName = TRANSFER;
                identificationTitleKey = 'documentation-identificationCardTitleTransfer';
                break;
            case IBAN:
                identificationIcon = IBAN;
                identificationClassName = IBAN;
                identificationTitleKey = 'documentation-identificationCardTitleIban';
                break;
            case CORREOS:
                identificationIcon = CORREOS;
                identificationClassName = CORREOS;
                identificationTitleKey = 'documentation-identificationCardTitleCorreos';
                break;
            case COURIER:
                identificationIcon = CORREOS;
                identificationClassName = COURIER;
                identificationTitleKey = 'documentation-identificationCardTitleCourier';
                break;
            case VIDEO_CALL:
                identificationIcon = VIDEO_CALL;
                identificationClassName = VIDEOCALL_CAMELCASE;

                if (userProfile.investmentType === CREDIT_CARD) {
                    identificationMethodTextKey = `documentation-identificationCardVideoCallCreditCard`;
                    identificationTitleKey = 'documentation-identificationCardTitleVideoCallCreditCard';
                    break;
                }

                identificationTitleKey = 'documentation-identificationCardTitleVideocall';
                break;
            case VIDEO_SELFIE:
                identificationIcon = VIDEO_CALL;
                identificationClassName = VIDEOCALL_CAMELCASE;
                identificationTitleKey = 'documentation-identificationCardTitleVideoselfie';
                break;
            default:
                identificationIcon = TRANSFER;
                identificationClassName = TRANSFER;

                const userInvestmentsType = {
                    [ROBO]: true,
                    [GBI]: true,
                    [ROBO_REJECTED]: true,
                    [GBI_REJECTED]: true,
                    [CREDIT_CARD]: false,
                };

                if (userInvestmentsType[userProfile.investmentType]) {
                    const transferAndExtraDocs = isMatchTransferCertificate && isMatchAnyExtraDocuments;

                    if (transferAndExtraDocs)
                        identificationMethodTextKey = `documentation-identificationCardRoboWithExtraDoc`;
                    else identificationMethodTextKey = `documentation-identificationCardRobo`;

                    identificationTitleKey = 'documentation-identificationCardTitleRobo';
                }

                break;
        }

        if (userProfile.jointHolderType === JOINT_HOLDER_AUTORIZED || !userProfile.isJointHolderNoClient) {
            identificationMethodCard = null;
        } else {
            identificationMethodCard = (
                <IdentificationCard
                    icon={identificationIcon}
                    className={`identification-card-container identification-card-container-${identificationClassName}`}
                    iconClassName={`identification-card-icon-${identificationClassName}`}
                    contentClassName={`identification-card-content-${identificationClassName}`}
                >
                    <span>
                        <h2>{formatText(identificationTitleKey)}</h2>
                        <br />
                        <p>{formatText(identificationMethodTextKey)}</p>
                        <br />
                        <ConditionalToggling condition={userProfile.investmentType === TRANSFER_CERTIFICATE}>
                            <p>
                                {formatText('documentation-identificationCardTitleTransferIbanCopy')}{' '}
                                <p className={'font-bolded-iban-identifyCard'}> {userProfile.iban} </p>
                                <p
                                    className={'iban-identifyCard-copy'}
                                    onClick={() => handleCopyIban(userProfile.iban)}
                                >
                                    <img height="18" width="19" src={copyIbanButton} />
                                </p>
                            </p>
                        </ConditionalToggling>
                    </span>
                </IdentificationCard>
            );
        }

        return identificationMethodCard;
    };

    const renderPromoCode = () => {
        const promoCode = promotionalCode.get('promotionalCode');
        let renderPromoCode = null;
        const isDepositProcess = isDeposit({ investmentType, onboardingType });

        if (isDepositProcess) {
            return null;
        }

        if (!promoCode.isEmpty()) {
            const url = promoCode.get('url');
            if (url) {
                const title = promoCode.get('title');
                const details = promoCode.get('details');
                const img = promoCode.get('img');

                renderPromoCode = (
                    <div className="promo-code-info__details">
                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <h4 className="font-heading3">
                                    <FormattedText value="promoCode-appliedPromotion" />
                                </h4>
                                <span className="dash"></span>
                            </div>
                            <div className={`col-xs-12 col-sm-6 ${!url ? 'hidden' : ''}`}>
                                <p className="font-paragraph2">
                                    <a href={url} target="_blank" className="promo-code__details-link" rel="noreferrer">
                                        <span>
                                            <FormattedText value="promoCode-seeConditions" />
                                        </span>
                                        <img height="10" width="10" src={iconComplementaryLink} />
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className={`col-xs-12 col-sm-4 ${!img ? 'hidden' : ''}`}>
                                <img className="img-responsive" src={img} />
                            </div>
                            <div className="col-xs-12 col-sm-8">
                                <h5 className="promo-code-info__details-subtitle">{title}</h5>
                                <p className="promo-code-info__details-description">{details}</p>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return renderPromoCode;
    };
    const getCardBoxes = () => {
        return immJointHoldersStatus.get('byOrder').map((holderId, index) => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);

            return (
                <JointHolderStatusCard
                    key={index}
                    immJointHolder={immJointHolder}
                    batchStatus={immJointHoldersStatus.get('batchStatus')}
                />
            );
        });
    };

    const getCardStatement = () => {
        let cardStatement;

        immJointHoldersStatus.get('byOrder').map(holderId => {
            const immJointHolder = immJointHoldersStatus.getIn(['byId', holderId.toString()]);

            if (immJointHolder.get('checkOpenCredit')) {
                cardStatement = (
                    <div className="card-info__aclaration clearfix">
                        <img src={CREDIT_CARD_BASIC} className="card-info__icon" />
                        <FormattedText value="cardInfo-standByFinalInfo" />
                    </div>
                );

                return;
            }
        });

        return cardStatement;
    };

    const buildJointHoldersResume = () => {
        const cardBoxes = getCardBoxes();
        const cardStatement = getCardStatement();

        return (
            <div>
                <div className="documentation-info-view__space"></div>

                <Accordion
                    id="holders"
                    title={formatText('jointHolderStatus-title')}
                    expandable={true}
                    isExpanded={false}
                    additionalComponent={cardStatement}
                >
                    <AccordionBody name="AccordionBody">{cardBoxes}</AccordionBody>
                </Accordion>
            </div>
        );
    };

    const renderWealthProduct = () => {
        const name = wealthProduct.get('wealthName');
        const type = wealthProduct.get('wealthType').toUpperCase();
        let upperTitle;
        let standByFinalText;
        switch (type) {
            case ISIN:
                upperTitle = 'investmentFund-upperTitle';
                standByFinalText = 'investmentFund-standByFinal';
                break;
            case DGS:
                upperTitle = 'pensionPlan-upperTitle';
                standByFinalText = 'pensionPlan-standByFinal';
                break;
            case INVD:
                upperTitle = 'portfolio-upperTitle';
                standByFinalText = 'portfolio-standByFinal';
                break;
            default:
                break;
        }

        return (
            <div>
                <div className="documentation-info-view__divider"></div>
                <div className="row documentation-info-view__fund">
                    <div className="col-xs-12">
                        <div className="documentation-info-view__fund-upper-title">
                            <FormattedText value={upperTitle} />
                        </div>
                        <div className="documentation-info-view__fund-name">{name}</div>
                        <span className="dash-blue" />

                        <div className="documentation-info-view__fund-text products-list__single-list">
                            <FormattedText value={standByFinalText} />
                        </div>
                    </div>
                </div>
                <div className="documentation-info-view__divider"></div>
            </div>
        );
    };

    const renderInvestmentCard = () => {
        const isRobo = userProfile.investmentType === ROBO;
        const investmentType = isRobo
            ? formatText('investmentPlan-titleStandBy')
            : formatText('investment-gbiTypeStandBy');
        const cardText = isRobo ? (
            <FormattedTextWithComponents value="investment-roboItemCard" />
        ) : (
            <FormattedTextWithComponents value="investment-gbiItemCard" />
        );
        let content;

        if (userProfile.investmentType) {
            content = (
                <div className={'card-investment'}>
                    <h5>{investmentType}</h5>
                    <div className="products-list__single-list">
                        <ul>
                            <li>{cardText}</li>
                        </ul>
                    </div>
                </div>
            );
        }

        return content;
    };

    const getCreditCardProduct = () => {
        const productsInfo = products.get('products');
        const openCreditCMSJaffar = getOpenCreditText();
        let result = null;

        productsInfo.map(product => {
            if (product.text === 'products-textOpenCredit') {
                result = <AuthorizedCreditCard openCreditCMSJaffar={openCreditCMSJaffar} />;
            }
        });

        return result;
    };

    const userDocumentation = documentation.get('filesToUpload');
    const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(userProfile.investmentType);
    const shouldHideDebitCardInfo = userProfile.isJointHolder && !userProfile.jointHolderData?.invite.openDebitCard;
    const debitCardInfo = shouldHideDebitCardInfo ? null : (
        <li>
            <span className="documentation-info-view__further__item-title">
                <FormattedText value="documentation-furtherItem3Title" />
            </span>
            <div className="documentation-info-view__further__subtitle">
                <FormattedText value="documentation-furtherItem3Text" />
            </div>
        </li>
    );
    const signatureKeyInfo = !flags.get(SIGNATURE_KEY_ENABLED) && (
        <li>
            <span className="documentation-info-view__further__item-title">
                <FormattedText value="documentation-furtherItem1Title" />
            </span>
            <div className="documentation-info-view__further__subtitle">
                <FormattedText value="documentation-furtherItem1Text" />
            </div>
        </li>
    );
    const creditCard = userProfile.creditCardOffer_accepted ? getCreditCardProduct() : null;
    const creditCardContainer = creditCard ? (
        <div>
            <div className="prospects-gutter prospects-prepend-margin basic-layering">{creditCard}</div>
            <div className="documentation-info-view__divider"></div>
        </div>
    ) : null;
    const promoCodeSectionContainer = renderPromoCode() ? (
        <div>
            <div className="prospects-gutter prospects-prepend-margin">{renderPromoCode()}</div>
            <div className="documentation-info-view__divider"></div>
        </div>
    ) : null;
    const iban = userProfile.iban;
    const showJointHoldersResume = userProfile.isJointHolderAccount ? buildJointHoldersResume() : null;
    const congratulationText = userProfile.isJointHolderAccount
        ? 'documentation-congratulationsTextJointHolder'
        : 'documentation-congratulationsText';
    const fundCard = wealthProduct.get('wealthType') && !userProfile.isJointHolder ? renderWealthProduct() : null;
    const fundCardContainer = fundCard ? (
        <div>
            <div className="prospects-gutter prospects-prepend-margin basic-layering">{fundCard}</div>
            <div className="documentation-info-view__divider"></div>
        </div>
    ) : null;
    const investmentCard =
        userProfile.investmentType === ROBO || userProfile.investmentType === GBI ? renderInvestmentCard() : null;
    const investmentCardContainer = investmentCard ? (
        <div>
            <div className="prospects-gutter prospects-prepend-margin">{investmentCard}</div>
            <div className="documentation-info-view__divider"></div>
        </div>
    ) : null;

    const textKeysSA =
        userProfile.investmentType === CREDIT_CARD
            ? {
                  congratulations: 'documentation-congratulationsTDC',
                  text: 'documentation-congratulationsTextTDC',
                  box: 'documentation-congratulationsEmailJointHolderTDC',
              }
            : {
                  congratulations: 'documentation-congratulations',
                  text: congratulationText,
                  box: 'documentation-congratulationsEmailJointHolder',
              };

    return (
        <div className="documentation-info-view">
            <div className="prospects-gutter prospects-prepend-margin basic-layering fix-margin-top">
                <div className="documentation-info-view__congratulations">
                    <h2 className="font-heading2 prospects-standByFinal-title">
                        <FormattedText value={textKeysSA.congratulations} injectedStrings={[userProfile.name]} />
                    </h2>
                    <span className="dash dash-margin" />
                    <p className="font-paragraph1 prospects-standByFinal-text">
                        <FormattedText value={textKeysSA.text} injectedStrings={[iban]} />
                    </p>
                    <Headline icon="standByFinal" className="prospects-standByFinal">
                        <p>
                            <FormattedText value={textKeysSA.box} />
                        </p>
                    </Headline>
                </div>

                <div className="documentation-info-view__pending">
                    {isDeposit({
                        investmentType: userProfile.investmentType,
                        onboardingType: userProfile.onboardingType,
                    }) && (
                        <MessageBox
                            boxColor="yellow"
                            iconColor="warning-yellow"
                            contentText={formatText('messagesScreen-standbyDeposit')}
                        />
                    )}
                    <h2 className="font-heading2 subheading prospects-standByFinal-title">
                        <FormattedText value="documentation-pendingVerificationTitle" />
                    </h2>
                    <span className="dash-blue" />
                    {renderIdentificationCard(userProfile.identityMethod)}
                    <DocumentationCard
                        userProfile={userProfile}
                        documentation={userDocumentation}
                        method={userProfile.identityMethod}
                    />
                    {showJointHoldersResume}
                </div>
            </div>

            <div className="documentation-info-view__divider"></div>

            {fundCardContainer}

            {investmentCardContainer}

            {creditCardContainer}

            <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                <div>
                    <div className="products-list products-list__container">{renderProducts()}</div>

                    <div className="documentation-info-view__divider hidden-xs"></div>
                </div>
            </ConditionalToggling>

            {promoCodeSectionContainer}

            {userInvestmentType[CREDIT_CARD] && partner && (
                <Fragment>
                    <FeatureSection
                        icon={getCreditCardImage(partner.get('id'))}
                        title={
                            <FormattedText
                                value={`documentation-TCTitle_${partner.get('id')}`}
                                injectedStrings={[creditCardLimit]}
                            />
                        }
                        itemList={[
                            `documentation-TCitem1_${partner.get('id')}`,
                            `documentation-TCitem2_${partner.get('id')}`,
                            `documentation-TCitem3_${partner.get('id')}`,
                            `documentation-TCitem4_${partner.get('id')}`,
                        ]}
                    />
                    <div className="documentation-info-view__divider" />
                </Fragment>
            )}

            <div className="prospects-gutter prospects-prepend-margin basic-layering">
                <div className="documentation-info-view__further">
                    <h3 className="font-heading3">
                        <FormattedText value="documentation-further" />
                    </h3>
                    <span className="dash-blue" />
                    <ConditionalToggling condition={userInvestmentType[CREDIT_CARD]}>
                        <ul>
                            <li>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-successFurtherItem1Text" />
                                </div>
                            </li>
                        </ul>
                    </ConditionalToggling>
                    <ConditionalToggling condition={!userInvestmentType[CREDIT_CARD]}>
                        <ul>
                            {signatureKeyInfo}
                            <li>
                                <span className="documentation-info-view__further__item-title">
                                    <FormattedText value="documentation-furtherItem2Title" />
                                </span>
                                <div className="documentation-info-view__further__subtitle">
                                    <FormattedText value="documentation-furtherItem2Text" />
                                </div>
                            </li>
                            {debitCardInfo}
                        </ul>
                    </ConditionalToggling>
                </div>
                <hr />
                <DocumentationContact />
            </div>
            <ButtonUnderstood onClick={doTagContinueButtonClick} />
        </div>
    );
};

module.exports.DocumentationInfo = connect(
    state => ({
        userProfile: state.userProfile,
        promotionalCode: state.promotionalCode,
        initialStep: state.initialStep,
        immJointHoldersStatus: state.jointHoldersStatus,
        products: state.products,
        documentation: state.documentation,
        wealthProduct: state.wealthProduct,
        cms: state.cms,
        partner: state.products.get('partner'),
    }),
    dispatch => ({
        stepsActions: bindActionCreators(stepsActions, dispatch),
        initialActions: bindActionCreators(initialActions, dispatch),
        promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
        documentationActions: bindActionCreators(documentationActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        cmsActions: bindActionCreators(cmsActions, dispatch),
        scoringActions: bindActionCreators(scoringActions, dispatch),
        creditCardActions: bindActionCreators(creditCardActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
    })
)(withFeatureToggling(DocumentationInfo));

DocumentationInfo.propTypes = {
    userProfile: PropTypes.object.isRequired,
    documentation: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    wealthProduct: PropTypes.object.isRequired,
    cms: PropTypes.object.isRequired,
    partner: PropTypes.object.isRequired,
    flags: PropTypes.object.isRequired,
    initialActions: PropTypes.object.isRequired,
    preLoaderActions: PropTypes.object.isRequired,
    cmsActions: PropTypes.object.isRequired,
    scoringActions: PropTypes.object.isRequired,
    jointHoldersStatusActions: PropTypes.object.isRequired,
    documentationActions: PropTypes.object.isRequired,
    creditCardActions: PropTypes.object.isRequired,
    promotionalCode: PropTypes.object.isRequired,
    initialStep: PropTypes.object.isRequired,
    immJointHoldersStatus: PropTypes.object.isRequired,
    standByActions: PropTypes.object.isRequired,
};
